import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { RiVideoOnLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';

import Archive from './Archive';
import styles from './index.module.scss';
import Live from './Live';
import RobotList from './RobotList';

import actions from '@/actions';
import Bar from '@/components/ui/Bar';
import BinarySwitch from '@/components/ui/BinarySwitch';
import ContainerFullHeight from '@/components/ui/ContainerFullHeight';
import TopBar from '@/components/ui/TopBar';
import useLoadRobots from '@/hooks/useLoadRobots';
import useLoadUser from '@/hooks/useLoadUser';

const cx = classNames.bind(styles);

const Page = () => {
  const dispatch = useDispatch();
  const [isShowRobotList, setShowRobotList] = useState(true);
  const [mode, setMode] = useState('live');

  // 계정 조회
  useLoadUser();
  // 로봇내역 조회
  useLoadRobots();

  const changeMode = (mode) => {
    dispatch(actions.robot.reset());
    setMode(mode);
  };

  const toggleRobotList = () => {
    setShowRobotList(!isShowRobotList);
  };

  return (
    <>
      <Helmet>
        <title>M1UCS | Video Manager</title>
      </Helmet>
      <ContainerFullHeight className={cx('container')}>
        <TopBar>
          <BinarySwitch
            items={[
              { title: 'Live', value: 0, onClick: () => changeMode('live') },
              { title: 'Archive', value: 1, onClick: () => changeMode('archive') },
            ]}
          />
        </TopBar>
        <div className={cx('middle')}>
          <div className={cx('sidebar')}>
            <div className={cx('groups')}>
              <Bar size={24} horizontal />
              <div className={cx('group')}>
                <div className={cx(['button', { active: isShowRobotList }])} onClick={toggleRobotList}>
                  <RiVideoOnLine size={20} color="white" />
                </div>
              </div>
            </div>
          </div>
          <div className={cx(['content', { hideRobotList: !isShowRobotList }])}>
            <div className={cx('wrapper')}>
              <RobotList />
              {mode === 'live' && <Live />}
              {mode === 'archive' && <Archive />}
            </div>
          </div>
        </div>
      </ContainerFullHeight>
    </>
  );
};

export default Page;
